"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const recharts_1 = require("recharts");
// Return configured axis for horizontal or vertical direction
const ChartAxisAndLegend = ({ direction }) => {
    if (direction === 'vertical') {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(recharts_1.XAxis, { type: "category", dataKey: "category", height: 60, tickFormatter: (value) => value, angle: -45, textAnchor: "end" // Align text properly
                , interval: 0 }),
            react_1.default.createElement(recharts_1.YAxis, null),
            react_1.default.createElement(recharts_1.Legend, { verticalAlign: "bottom", height: 36, wrapperStyle: { paddingTop: '10px' } })));
    }
    else {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(recharts_1.XAxis, { type: "number" }),
            react_1.default.createElement(recharts_1.YAxis, { type: "category", dataKey: "category" }),
            react_1.default.createElement(recharts_1.Legend, { verticalAlign: "bottom" })));
    }
};
/**
 * Generic component to show a bar chart of started and completed interviews by
 * a given attribute
 *
 * @param attributeName the attribute by which to make the graph
 * @returns A component with a bar chart for completed and started interview by
 * the given attribute
 */
const StartedAndCompletedByAttribute = ({ attributeName, direction = 'vertical' }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [data, setData] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        fetch('/api/admin/data/startedCompletedByAttribute?attribute=' + encodeURIComponent(attributeName), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
            // TODO Handle errors better, currently, the graph is simply
            // absent from the status page (returns null)
            if (response.status === 200) {
                response
                    .json()
                    .then((jsonData) => {
                    const dataForChart = [];
                    const sortedCategories = Object.keys(jsonData.started).sort();
                    for (let i = 0, count = sortedCategories.length; i < count; i++) {
                        const category = sortedCategories[i];
                        const completedCount = jsonData.completed[category] || 0;
                        const completedRatio = completedCount / jsonData.started[category];
                        // Translation strings can be added in the surveyAdmin.yml translation file with the key pattern: {attributeName}Categories: under which are the categories
                        const translatedCategory = t(`surveyAdmin:${attributeName}Categories:${category}`, {
                            defaultValue: category
                        });
                        dataForChart.push({
                            category: `${translatedCategory} (${Math.round(completedRatio * 1000) / 10})%`,
                            started: jsonData.started[category],
                            completed: completedCount
                        });
                    }
                    setData(dataForChart);
                })
                    .catch((err) => {
                    console.log('Error converting data to json.', err);
                });
            }
        })
            .catch((err) => {
            console.log('Error fetching data.', err);
        });
    }, []);
    // FIXME Maybe we should still return a placeholder to show there is no data
    if (data.length === 0) {
        return null;
    }
    // Either constraint the width or height depending on the direction, to show
    // all data
    // FIXME Improve style when moving the Evolution. The horizontal chart takes
    // full width of page, it should be bounded to something, but what?
    const constrainedSize = Math.min(1600, Math.max(250, data.length * 30 + 150));
    const divStyle = direction === 'vertical'
        ? { width: `${constrainedSize}px`, height: '100%' }
        : { height: `${constrainedSize}px`, width: '100%' };
    return (react_1.default.createElement("div", { className: "admin-widget-container", style: divStyle },
        react_1.default.createElement("p", { className: "no-bottom-margin" },
            react_1.default.createElement("strong", null, t('surveyAdmin:StartedAndCompletedInterviewsPer', {
                attribute: t(`surveyAdmin:${attributeName}`, { defaultValue: attributeName })
            }))),
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: "100%", height: "85%" },
            react_1.default.createElement(recharts_1.BarChart, { layout: direction === 'vertical' ? 'horizontal' : 'vertical', width: 500, height: 300, data: data, margin: {
                    top: 20, // Increased top margin to make room for the title
                    right: 30,
                    left: 20,
                    bottom: 70
                } },
                react_1.default.createElement(recharts_1.CartesianGrid, { strokeDasharray: "3 3" }),
                react_1.default.createElement(ChartAxisAndLegend, { direction: direction }),
                react_1.default.createElement(recharts_1.Tooltip, null),
                react_1.default.createElement(recharts_1.Bar, { dataKey: "started", name: t('admin:StartedFem'), fill: "#A4DB4F", activeBar: react_1.default.createElement(recharts_1.Rectangle, { stroke: "blue" }) }),
                react_1.default.createElement(recharts_1.Bar, { dataKey: "completed", name: t('admin:CompletedFem'), fill: "#428626", activeBar: react_1.default.createElement(recharts_1.Rectangle, { stroke: "blue" }) }))),
        react_1.default.createElement("a", { href: `/api/admin/data/startedCompletedByAttributeCsv?attribute=${encodeURIComponent(attributeName)}` }, t('surveyAdmin:CSV'))));
};
exports.default = StartedAndCompletedByAttribute;
